import { render } from "./ApplicationGroupDetail.vue?vue&type=template&id=af5fdd3a&scoped=true"
import script from "./ApplicationGroupDetail.vue?vue&type=script&lang=js"
export * from "./ApplicationGroupDetail.vue?vue&type=script&lang=js"

import "./ApplicationGroupDetail.vue?vue&type=style&index=0&id=af5fdd3a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5fdd3a"]])

export default __exports__